module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('data-table', {
    ref: "contractors-table",
    attrs: {
      "title": _vm.title,
      "url": "/contractors",
      "fields": _vm.fields,
      "table-ref": "contractors-table",
      "detail-component": "contractor-detail-row"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-980fc83c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/finance/invoice/ContractorInvoiceTable.vue
// module id = 1596
// module chunks = 0